// DialogService.ts
import { createApp, nextTick } from 'vue';
import DialogAlert from '@/Components/UI/DialogAlert.vue';

let _dialogOpen = false;

export const DialogService = {
  confirm(options) {
    if (_dialogOpen) return Promise.resolve(false);
    _dialogOpen = true;

    return new Promise((resolve) => {
      const container = document.createElement('div');
      container.classList.add('dialog-container');

      function cleanup() {
        _dialogOpen = false;
        nextTick(() => {
          try { dialogInstance.unmount(); } catch (_) {}
          container.remove();
        });
      }

      let dialogInstance;
      try {
        dialogInstance = createApp(DialogAlert, {
          ...options,
          additionalButtons: options.additionalButtons || [],
          showDialog: true,
          onConfirm: () => { resolve(true); cleanup(); },
          onDeny: () => { resolve(false); cleanup(); },
          onCustomAction: (customAction) => { customAction?.(); resolve(false); cleanup(); },
        });

        (document.querySelector('#app') || document.body).appendChild(container);
        dialogInstance.mount(container);
      } catch (_) {
        cleanup();
        resolve(false);
        return;
      }

      // iOS: forzamos foco real en el botón Cancelar (marcado con data-cancel)
      const focusCancel = () => {
        const btn = container.querySelector('[data-cancel]');
        if (btn instanceof HTMLElement) {
          btn.focus();
          setTimeout(() => btn.blur(), 100);
        }
      };

      nextTick(() => {
        focusCancel();
        setTimeout(focusCancel, 60);
      });
    });
  },
  confirmDate(options) {
    return new Promise((resolve) => {
      const dialogInstance = createApp(DialogAlert, {
        ...options,
        showDateInput: true,
        dateRequired: true,
        additionalButtons: options.additionalButtons || [],
        showDialog: true,
        onConfirm: (dateValue) => { resolve(dateValue || null); cleanup(); },
        onDeny: () => { resolve(null); cleanup(); },
        onCustomAction: (customAction, dateValue) => { customAction?.(dateValue || null); resolve(dateValue || null); cleanup(); },
      });

      const container = document.createElement('div');
      container.classList.add('dialog-container');
      (document.querySelector('#app') || document.body).appendChild(container);
      dialogInstance.mount(container);

      function cleanup() {
        nextTick(() => {
          dialogInstance.unmount();
          container.remove();
        });
      }
    });
  },
};
